__webpack_require__.p = "/Cryptocurrency/";